export default {
      id: "x-circle-usage",
      viewBox: "0 0 33 33",
      url: __webpack_public_path__ + "sprite.svg#x-circle",
      toString: function () {
        return this.url;
      }
    }